
import axios from "axios";
import { defineComponent } from "vue";
import ModalCom1 from "@/components/ModalCom1.vue";

interface ColumnItem {
  prop: string;
  label: string;
  show: boolean;
  fixed?: string;
  width: string;
  sortable?: boolean;
  html?: boolean;
}

export default defineComponent({
  components: {
    ModalCom1,
  },
  data() {
    return {
      tableUrl: "/php/spa_table.php",
      configUrl: "/php/spa_config.php",
      spaConfig: [] as any[],
      columns: [] as ColumnItem[],
      tableItem: [] as any[],
      tableHeight: 500,
      dataLoading: false,
      commSpa: "",
      commName: "",
    };
  },
  methods: {
    async fetchConfig() {
      try {
        const res = await axios.post(this.configUrl, { action: "selectAll" });
        this.spaConfig = res.data || [];
      } catch (error) {
        console.error("取得 SPA 設定失敗:", error);
      }
    },

    async loadLastComments() {
      this.dataLoading = true;
      try {
        if (this.spaConfig.length === 0) {
          await this.fetchConfig();
        }

        const now = new Date();
        now.setDate(now.getDate() - 7);
        const dateStr = now.toISOString().split("T")[0];

        const commentRes = await axios.post(this.tableUrl, {
          action: "selectLastComment",
          date: dateStr,
        });

        const commentData = commentRes.data || [];

        if (!Array.isArray(commentData) || commentData.length === 0) {
          this.tableItem = [];
        } else {
          const requests = commentData.map((item: any) =>
            axios.post(this.tableUrl, {
              action: "searchCommentByName",
              table_name: item.spa,
              name: item.name,
            })
          );

          const responses = await Promise.all(requests);
          const aggregatedList: any[] = [];

          responses.forEach((res, index) => {
            const itemSpaId = commentData[index]?.spa;
            const spaConfigItem = this.spaConfig.find((e) => e.id === itemSpaId);
            const spaName = spaConfigItem ? spaConfigItem.name : "";

            if (Array.isArray(res.data)) {
              res.data.forEach((row: any) => {
                let imgUrl = row.image || "";
                if (imgUrl && !imgUrl.startsWith("http")) {
                  imgUrl = "https://imgf.gg9453.com/images/spa_daily/" + imgUrl;
                }

                let ex = "";
                if (row.music === "true") ex += "、送音樂";
                if (row.bento) ex += "、套餐" + row.bento;
                ex = ex.startsWith("、") ? ex.substring(1) : ex;

                let info = row.info || "";
                if (row.name_his) {
                  info = info + "<br>" + row.name_his;
                }

                let week = "";
                if (row.w1) week += "一" + row.w1 + "<br>";
                if (row.w2) week += "二" + row.w2 + "<br>";
                if (row.w3) week += "三" + row.w3 + "<br>";
                if (row.w4) week += "四" + row.w4 + "<br>";
                if (row.w5) week += "五" + row.w5 + "<br>";
                if (row.w6) week += "六" + row.w6 + "<br>";
                if (row.w7) week += "日" + row.w7 + "<br>";

                aggregatedList.push({
                  ...row,
                  image: imgUrl,
                  spa_name: spaName,
                  spa_id: itemSpaId,
                  ex: ex,
                  info: info,
                  week: week,
                });
              });
            }
          });

          this.tableItem = aggregatedList;
        }
      } catch (error) {
        console.error("載入最新心得失敗:", error);
        this.tableItem = [];
      } finally {
        this.dataLoading = false;
      }
    },

    format1(scope: any) {
      if (1 == scope.cellIndex && "true" == scope.row.day_push) {
        return '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"><br>';
      }
      if (1 == scope.cellIndex && "true" == scope.row.is_new) {
        return '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"><br>';
      }
      return "";
    },

    doButton(spa1: string, name1: string) {
      this.commSpa = spa1;
      this.commName = name1;
    },

    initColumns() {
      if (window.innerWidth < 600) {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "85px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "120px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "spa_name", label: "店家", show: false, sortable: true, width: "80px" },
          { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "300px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      } else {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "120px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "200px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "spa_name", label: "店家", show: false, sortable: true, width: "90px" },
          { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "270px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      }
    },
  },
  created() {
    this.tableHeight = Math.max(window.innerHeight - 300, 500);
    this.initColumns();
  },
  mounted() {
    this.loadLastComments();
  },
});
